import { render, staticRenderFns } from "./Saffron.vue?vue&type=template&id=2e9dff76&"
import script from "./Saffron.vue?vue&type=script&lang=js&"
export * from "./Saffron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports